import React from 'react'
import { Button, Row, Modal, notification } from 'antd'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import StyledInput from '@nexys/components/Input'

import ApiCall from 'services/ApiCall'
import { useMutation } from 'react-query'
import classNames from '../Header.module.scss'

interface ChangePasswordAttributes {
  newPassword: string
}

export default function ModalPassword(props) {
  const { active, setActive, userId, setActiveProfile, logout } = props

  const changePassword = useMutation((data: ChangePasswordAttributes) => ApiCall.User.update(userId, data))
  
  return (
    <Modal
      style={{
        justifyContent: 'center',
        alignItems: 'center'
      }}
      visible={active}
      footer={null}
      onCancel={() => {
        setActiveProfile(true)
        setActive(!active)
      }}
    >
      <Formik
        initialValues={{ newPassword: '', password: '' }}
        validationSchema={yup.object().shape({
          newPassword: yup.string().required('Password harus diisi!'),
          password: yup.string().oneOf([yup.ref('newPassword'), null],'Password tidak sama').min(8, 'Password minimal 8 karakter'),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true)
          try {
            const res = await changePassword.mutateAsync(values)

            if (res.data.error) {
              notification.error({
                message: res.data.error?.data?.message,
              })
              return
            }

            notification.success({
              message: res.data?.message,
            })
            setActive(!active)
            setActiveProfile(true)
            notification.success({
              message: `Silahkan Masuk Kembali Dengan Password Baru`,
            })
            logout('/login')
          } catch (error) {
            notification.error({
              message: error.response.data?.message,
            })

            setSubmitting(false)
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {({ handleChange, isSubmitting }) => (
          <Form>
            <Row
              align="middle"
              gutter={10}
              justify="center"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <StyledInput
                style={{ width: '100%' }}
                topSpace={40}
                label={'New password'}
                id="newPassword"
                name="newPassword"
                type="password"
                bordered
                required
                handleChange={handleChange}
              />
              <StyledInput
                topSpace={30}
                label={`Re-type new password`}
                id="password"
                name="password"
                type="password"
                bordered
                required
                handleChange={handleChange}
              />
              <Button
                className={classNames.save}
                disabled={isSubmitting}
                htmlType="submit"
                size="large"
              >
                Simpan
              </Button>
            </Row>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}
